import ModulLiveClassReport from "@/modules/live_class_report/components/LiveClassReport";

export default [
    {
        path: "/live-class-report",
        name: "LiveClassReport",
        component: ModulLiveClassReport,
    },
];



// WEBPACK FOOTER //
// ./src/modules/live_class_report/router/liveclassreport.js